import { createReducer, on, Action } from '@ngrx/store';
import { ApiError, DDAccountVerifyResponse } from '../../client/src';
import { IDirectDebitDetails, LoadState } from '@nx-ng/types';
import { DirectDebitActions } from '../../actions';
import { EMPTY_DIRECT_DEBIT } from '@nx-ng/constants';
import { DIRECT_DEBIT_NOT_FOUND } from '../../constants';

export interface IDirectDebitState {
  directDebitResponse?: DDAccountVerifyResponse;
  loaded: LoadState;
  error?: ApiError | string;
  directDebitForm: IDirectDebitDetails;
}

export const initialState: IDirectDebitState = {
  loaded: LoadState.NOT_LOADED,
  directDebitForm: EMPTY_DIRECT_DEBIT,
};

const diretDebitReducer = createReducer(
  initialState,
  on(DirectDebitActions.checkoutAPI_verifyDirectDebitDetails, (state) => ({
    ...state,
    loaded: LoadState.LOADING,
    error: undefined,
  })),
  on(
    DirectDebitActions.checkoutAPI_verifyDirectDebitDetailsSuccess,
    (state, { response }: { response: DDAccountVerifyResponse }) => ({
      ...state,
      directDebitResponse: response,
      loaded: LoadState.LOADED,
    })
  ),
  on(
    DirectDebitActions.checkoutAPI_verifyDirectDebitDetailsFailure,
    (state, { error }) => ({
      ...state,
      error,
      loaded: LoadState.FAILED,
      directDebitResponse: DIRECT_DEBIT_NOT_FOUND,
    })
  ),
  on(
    DirectDebitActions.checkoutAPI_verifyDirectDebitDetailsNotFound,
    (state) => ({
      ...state,
      loaded: LoadState.LOADED,
      directDebitResponse: DIRECT_DEBIT_NOT_FOUND,
    })
  ),
  on(DirectDebitActions.clearDirectDebitVerfification, (state) => ({
    ...state,
    directDebitResponse: undefined,
    loaded: LoadState.NOT_LOADED,
  })),
  on(DirectDebitActions.saveDirectDebitForm, (state, { directDebitForm }) => ({
    ...state,
    directDebitForm,
  }))
);

export function reducer(state: IDirectDebitState | undefined, action: Action) {
  return diretDebitReducer(state, action);
}
